import React, { useState, useEffect } from "react";
import "../Style.css";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import { updateTemplate, getTemplate } from "../services/templateService";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

export default function TemplateForm() {
  const { id } = useParams();

  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    category: "",
    code: "",
    previewUrl: "",
    description: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const loadTemplates = async () => {
    
    const res = await getTemplate(id);
    let templateData = res?.data?.data;

    if (templateData != null) {
      setForm({
        name: templateData.name,
        category: templateData.category,
        code: templateData.code,
        previewUrl: templateData.previewUrl,
        description: templateData.description,
      });
    }
  };

  useEffect(() => {
    loadTemplates();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let res = await updateTemplate(id, form);
      if (res?.data?.success) {
        toast.success("Template has been created, successfully.");
        navigate("/templateList");
      } else {
        toast.error("Faild, please try again.");
      }
    } catch (err) {
      alert("Error saving template");
    }
  };

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <Sidebar />
          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
          <br />
            <h3>Update Template</h3>
            <br />
            <form onSubmit={handleSubmit} className="mb-4">
              <div className="mb-2">
                <input
                  className="form-control"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Template Name"
                  required
                />
              </div>
              <div className="mb-2">
                <input
                  className="form-control"
                  name="category"
                  value={form.category}
                  onChange={handleChange}
                  placeholder="Category"
                />
              </div>
              <div className="mb-2">
                <input
                  className="form-control"
                  name="previewUrl"
                  value={form.previewUrl}
                  onChange={handleChange}
                  placeholder="Preview URL"
                  required
                />
              </div>
              <div className="mb-2">
                <textarea
                  className="form-control"
                  name="code"
                  value={form.code}
                  onChange={handleChange}
                  placeholder="Template Code (HTML/CSS/JS)"
                />
              </div>
              <div className="mb-2">
                <input
                  className="form-control"
                  name="description"
                  value={form.description}
                  onChange={handleChange}
                  placeholder="Description"
                />
              </div>
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </form>
          </main>
        </div>
      </div>
      <Footer />
    </>
  );
}
